import { SourceChoiceEnum } from 'api';
import { PriceAndCurrencyField, SelectField, type SelectOption, TextField, useFormContext } from 'form';
import { Grid, Typography } from 'ui';

import { useTransitTimeEstimator, useTransportEstimator } from '../../hooks';

const TRANSPORT_COST_SOURCE_OPTIONS: SelectOption[] = [
  {
    label: 'Transport cost estimate',
    value: SourceChoiceEnum.ESTIMATE,
  },
  {
    label: 'Logistics quote',
    value: SourceChoiceEnum.LOGISTICS_QUOTE,
  },
  {
    label: 'Other',
    value: SourceChoiceEnum.OTHER,
  },
];

export const CostsSection = () => {
  const { watch } = useFormContext();
  const { estimateTransportPrice } = useTransportEstimator();
  const { estimateTransitTime } = useTransitTimeEstimator();
  const watchTransportCostSource = watch('transport_cost_source');

  const estimateTransportAndTransitTime = () => {
    estimateTransportPrice();
    estimateTransitTime();
  };
  // disabling transport cost input when ESTIMATE source is selected - it
  // will be pulled automatically in this case
  const shouldDisableTransportCostInput = watchTransportCostSource === SourceChoiceEnum.ESTIMATE;
  return (
    <>
      <Typography variant="h5">Costs</Typography>
      <Grid container spacing={4}>
        <Grid item xs={12} md={3}>
          <PriceAndCurrencyField
            label="Seller price /t"
            priceName="seller_price_per_tonne"
            currencyName="seller_currency"
            required
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <PriceAndCurrencyField
                label="Shipping & customs cost / load"
                priceName="shipping_cost_per_load"
                currencyName="shipping_cost_per_load_currency"
                onCurrencyChange={estimateTransportAndTransitTime}
                disabled={shouldDisableTransportCostInput}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                label="Est. Full (Site-Site) Transit Time Days"
                type="number"
                name="estimated_transit_time_days"
              />
            </Grid>
            <Grid item xs={12}>
              <SelectField
                name="transport_cost_source"
                label="Shipping cost source"
                options={TRANSPORT_COST_SOURCE_OPTIONS}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} md={3}>
          <PriceAndCurrencyField
            label="Buyer agent commission /t"
            priceName="buyer_agent_commission"
            currencyName="buyer_agent_commission_currency"
          />
        </Grid>
        <Grid item xs={12} md={3}>
          <PriceAndCurrencyField
            label="Seller agent commission /t"
            priceName="seller_agent_commission"
            currencyName="seller_agent_commission_currency"
          />
        </Grid>
      </Grid>
    </>
  );
};
